module.exports = __webpack_public_path__ + "img/Bg.c398f36b.png";